import {Mapper} from '@s-ui/domain'

export class AdsRawListToAdsListVOMapper extends Mapper {
  constructor({config, adEntityFactory, adsListValueObjectFactory}) {
    super()
    this._adEntityFactory = adEntityFactory
    this._adsListValueObjectFactory = adsListValueObjectFactory
  }

  map = adsRawList => {
    const items = adsRawList.map(rawAd => {
      return this._adEntityFactory({
        id: rawAd.id,
        url: rawAd.url
      })
    })
    const adsList = this._adsListValueObjectFactory({items})
    return adsList
  }
}
